import React from 'react'
import { useIntl } from 'react-intl'
import formatOfferInclusionDescription from 'lib/offer/formatOfferInclusionDescription'
import LinePriceTagAltIcon from 'LuxKit/Icons/line/LinePricetagAltIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { STANDARD_INCLUSION_TYPE, sortByInclusionPriority, type InclusionType } from './cruiseStandardInclusionUtils'

interface Props {
  standardInclusions: Array<App.PackageInclusion>
  type?: InclusionType
  allInclusions?: boolean
}

function CruiseStandardInclusionList({ standardInclusions, type, allInclusions = false }: Props) {
  const intl = useIntl()
  const inclusions = [...standardInclusions
    .filter(({ parentCategory }) =>
      allInclusions || (type != null && parentCategory === type),
    )]
    .sort(sortByInclusionPriority)

  return <>
    {!!inclusions.length && inclusions.map((inclusion) => {
      const Icon = inclusion.parentCategory === STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT ? LineUsdCircleIcon : LinePriceTagAltIcon
      return (
        <BodyTextBlock
          key={inclusion.id}
          startIcon={<Icon colour="highlight-primary-dark" />}
          weight="bold"
          variant="medium"
          colour="highlight-primary-dark"
        >
          {formatOfferInclusionDescription(inclusion.description, intl)}
        </BodyTextBlock>
      )
    })}
  </>
}

export default CruiseStandardInclusionList
